import { render } from "./loginauto.vue?vue&type=template&id=edaa5ecc"
import script from "./loginauto.vue?vue&type=script&lang=js"
export * from "./loginauto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__